var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4829 8.98524L12.0507 10.553C12.2615 10.7638 12.2615 11.1056 12.0507 11.3164C10.9109 12.4561 9.10651 12.5844 7.81703 11.6173L6.88436 10.9178C5.85216 10.1436 4.93524 9.22669 4.16109 8.1945L3.46159 7.26183C2.49448 5.97235 2.62271 4.16795 3.76247 3.0282C3.97328 2.81738 4.31508 2.81738 4.52589 3.0282L6.09362 4.59592C6.32481 4.82712 6.32481 5.20196 6.09362 5.43316L5.48908 6.03769C5.39301 6.13377 5.36919 6.28054 5.42995 6.40206C6.13247 7.8071 7.27176 8.94638 8.6768 9.6489C8.79832 9.70967 8.94509 9.68585 9.04117 9.58978L9.6457 8.98524C9.8769 8.75405 10.2517 8.75405 10.4829 8.98524Z",
    stroke: "#111111",
    strokeWidth: 0.592014
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLight);
export default __webpack_public_path__ + "static/media/Phone_light.458584d3c49783e1f4f57cc5b50fa68d.svg";
export { ForwardRef as ReactComponent };